<mat-form-field class="w-100" appearance="outline" floatLabel="always">
  <mat-label *ngIf="title">{{ title | translate }}</mat-label>
  <input
    #phone
    matInput
    [placeholder]="placeholder | translate"
    [formControl]="control"
    autocomplete="tel"
  />
  <mat-hint *ngIf="get(controlName)?.hasError('pattern')">
    {{ hint | translate }}. &nbsp;
  </mat-hint>
  <mat-hint *ngIf="get(controlName)?.hasError(controlName)">
    {{ hint | translate }}. &nbsp;
  </mat-hint>
  <mat-hint *ngIf="get(controlName)?.hasError('required')">{{
    "REQUIRED" | translate
  }}</mat-hint>
  <mat-error *ngIf="getServerError(controlName)">
    {{ getServerError(controlName) }}
  </mat-error>
</mat-form-field>
